import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useProjectStore } from '@/stores/project'

export const projectPartGeneralGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const projectStore = useProjectStore()
  const meta = projectStore.getMeta

  if (!meta || !meta.canEdit) {
    return next({ name: 'setup-project-view' })
  }
  next()
}
